import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Select } from "antd";
import { createProduct, updateProduct } from "../../services/product";

const { Option } = Select;

class ProductFormModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disableOkButton: false
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.prepareForm = this.prepareForm.bind(this);
        this.formRef = React.createRef();
    }

    async onFormSubmit() {
        const { data, editing, setVisible, reloadData, reloadAfterCreate } = this.props;
        await this.setState({
            disableOkButton: true
        })
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }

        if (passed) {
            if (!editing) {
                await createProduct(values)
                reloadAfterCreate();
            }
            else {
                await updateProduct(data['id'], values)
                reloadData();
            }
            setVisible(false);
        }
        this.setState({
            disableOkButton: false,
        })
    };

    componentDidMount() {
        this.props.onRef(this);
    }

    async prepareForm() {

    }

    render() {
        const { editing, visible, setVisible, data } = this.props;
        const { disableOkButton } = this.state;

        return (
            <Modal
                visible={visible}
                onCancel={() => { setVisible(false) }}
                onOk={this.onFormSubmit}
                title={editing ? "แก้ไขรายการ" : "เพิ่มรายการ"}
                okText={editing ? "แก้ไข" : "เพิ่ม"}
                cancelText={"ปิด"}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
                okButtonProps={{ disabled: disableOkButton }}
            >
                <Form
                    ref={this.formRef}
                    layout={'vertical'}
                    initialValues={data}
                >
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อสินค้า"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่ชื่อสินค้า"
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="รายละเอียด"
                                name="description"
                                rules={[]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

export default ProductFormModal;